import { differenceInCalendarDays } from 'date-fns';

function numberOfDays(start: Date, end: Date) {
    // number of days inclusive of the start date
    const days = Math.abs(differenceInCalendarDays(start, end)) + 1;
    return Number.isNaN(days) ? 0 : days;
}

export default numberOfDays;
